"use strict";
import fetch from "../util/fetch";
export default {
  verification: function(args) {
    return fetch(`/api/factor_invoices/${args.factorInvoiceId}/verification`, {
      method: "POST",
      data: { timestamp: args.timestamp }
    });
  }
};
